// let utils = require('../../utils')
export default {
  name: 'shop-order-detail-record',
  props: {
    shopOrderDetail: {
      type: Object,
      required: true,
      default: () => ({})
    },
    index: {
      type: Number,
      required: true,
      default: 0
    },
    status: {
      type: String,
      required: true,
      default: ''
    },
    isZeroInfinitySendCost: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  async created () {
    this.defaultOrderLotQuantity = this.shopOrderDetail.order_lot_quantity
    this.defaultStockQuantity = this.shopOrderDetail.stock_quantity
  },
  data () {
    return {
      isChangeOrderLotQuantity: false,
      isChangeStockQuantity: false,
      defaultOrderLotQuantity: 0,
      defaultStockQuantity: 0
    }
  },
  computed: {
    imagePath () {
      return this.shopOrderDetail.image_path + '?token=' + window.localStorage.getItem('access_token')
    },
    formatedLotPrice () {
      return this.shopOrderDetail.lot_price.toLocaleString()
    },
    formatedSubTotalPrice () {
      return (this.shopOrderDetail.order_lot_quantity * this.shopOrderDetail.lot_price).toLocaleString()
    },
    orderLotQuantity: {
      get () {
        return this.shopOrderDetail.order_lot_quantity
      },
      set (newVal) {
        if (this.shopOrderDetail.order_lot_quantity !== newVal) this.$emit('set-order-lot-quantity', newVal, this.index)
      }
    },
    stockQuantity: {
      get () {
        return this.shopOrderDetail.stock_quantity
      },
      set (newVal) {
        if (this.shopOrderDetail.stock_quantity !== newVal) this.$emit('set-stock-quantity', newVal, this.index)
      }
    },
    isZeroInfinitySendCostAndTargetRecord () {
      return this.isZeroInfinitySendCost && this.shopOrderDetail.fee_type === 'zero_infinity'
    },
    isCanEdit () {
      return this.status !== 'head_office_confirmed' && this.status !== 'order_completed'
    }
  },
  methods: {
    updateOrderLotQuantity () {
      this.$emit('update-order-lot-quantity', this.index)
      this.defaultOrderLotQuantity = this.shopOrderDetail.order_lot_quantity
      this.isChangeOrderLotQuantity = false
    },
    resetOrderLotQuantity () {
      this.$emit('set-order-lot-quantity', this.defaultOrderLotQuantity, this.index)
      this.isChangeOrderLotQuantity = false
    },
    updateStockQuantity () {
      this.$emit('update-stock-quantity', this.index)
      this.defaultStockQuantity = this.shopOrderDetail.stock_quantity
      this.isChangeStockQuantity = false
    },
    resetStockQuantity () {
      this.$emit('set-stock-quantity', this.defaultStockQuantity, this.index)
      this.isChangeStockQuantity = false
    },
    background () {
      if (this.shopOrderDetail.is_can_order === 0) {
        return 'is-can-order-record'
      } else if (this.isZeroInfinitySendCost && this.shopOrderDetail.fee_type === 'zero_infinity') {
        return 'zero-infinity-record'
      } else {
        return ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/shop-order-detail-record.js